import { AddressGet } from "../models/address-get";
import { ClassSchedule } from "../models/class-schedule";

export class Location {
  id: string;
  name: string;
  description: string;
  url: string;
  address: AddressGet;
  formattedAddress: string;
  distanceToStudent: number;
  distanceToStudentDisplay: string;
  classSchedules: ClassSchedule[];
  handicapAccess: boolean;
  maxCapacity: number;
  dipCommEd: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/location.ts